let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aacJW")).then(() => parcelRequire('1AwK4'));